// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  baseHref: '/',
  firebase: {
    apiKey: "AIzaSyB4wdMS9EGXeG3OsQQ-3ghSTkO8xDkUiPY",
    authDomain: "random-ride-1515186172972.firebaseapp.com",
    databaseURL: "https://random-ride-1515186172972.firebaseio.com",
    projectId: "random-ride-1515186172972",
    storageBucket: "random-ride-1515186172972.appspot.com",
    messagingSenderId: "174971899745"
  }
};



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/environments/environment.ts